import { Box, Chip, Stack, Typography } from "@mui/material";
import type { SoilChemistryInputDTO, SoilChemistryResultDTO } from "@flaha/shared-types";
import { SoilTestLevel } from "@flaha/shared-types";

import { GlassSurface } from "../../../layouts/components/GlassSurface";
import { PROVENANCE_CHIP } from "../utils/provenanceLabels";
import { ChemistryResultCard } from "./ChemistryResultCard";

interface ChemistryResultsCardProps {
	result: SoilChemistryResultDTO | null | undefined;
	testLevel?: SoilTestLevel | null | undefined;
	chemistryInput?: SoilChemistryInputDTO | null | undefined;
}

export function ChemistryResultsCard({ result, testLevel, chemistryInput }: ChemistryResultsCardProps) {
	const evidenceLabel = result
		? PROVENANCE_CHIP.calculated
		: testLevel === SoilTestLevel.PRELIMINARY
			? PROVENANCE_CHIP.reportedInputsOnly
			: PROVENANCE_CHIP.unavailable;

	return (
		<GlassSurface component="section" aria-labelledby="chemistry-results-title" sx={{ height: "100%", p: 1 }}>
			<Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ px: 1.5, pt: 1 }}>
				<Typography id="chemistry-results-title" component="h2" variant="overline" color="text.secondary">
					Chemistry evidence
				</Typography>
				<Chip label={evidenceLabel} size="small" variant="outlined" />
			</Stack>
			<Box sx={{ "& > .MuiCard-root": { bgcolor: "transparent", border: 0, boxShadow: "none" } }}>
				<ChemistryResultCard result={result} testLevel={testLevel} chemistryInput={chemistryInput} />
			</Box>
		</GlassSurface>
	);
}
